import { render } from "./App.vue?vue&type=template&id=1fdfda6b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1fdfda6b&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Master-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__